module.exports = __webpack_public_path__ + "img/mg.03255232.png";